import Alpine from "alpinejs";

Alpine.data('carousel', (id) => {
  return {
    id: id,
    get container() {
      return this.$el;
    },
    init() {
      this.setupEventListeners();
    },
    setupEventListeners() {
      window.addEventListener(`scroll-carousel:${this.id}:next`, () => {
        this.scrollNext();
      });
      window.addEventListener(`scroll-carousel:${this.id}:previous`, () => {
        this.scrollPrevious();
      });
      window.addEventListener(`scroll-carousel:${this.id}:to`, (event) => {
        this.scrollTo(event.detail.index);
      });
    },
    scrollNext() {
      this.container._scrollBy({
        left: this.container.offsetWidth,
        behavior: 'smooth',
      });
    },
    scrollPrevious() {
      this.container._scrollBy({
        left: -this.container.offsetWidth,
        behavior: 'smooth',
      });
    },
    scrollTo(index) {
      const child = this.container.children[index];

      if (child) {
        this.container.scrollTo({
          left: index === 0 ? 0 : (
            this.container.scrollLeft + 
            (child.getBoundingClientRect().left - this.container.getBoundingClientRect().left)
          ),
          behavior: 'smooth',
        });
      }
    },
  };
});